import { render, staticRenderFns } from "./DebtL_List.vue?vue&type=template&id=1825db5b"
import script from "./DebtL_List.vue?vue&type=script&lang=js"
export * from "./DebtL_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports